import { render, staticRenderFns } from "./DkIcon.vue?vue&type=template&id=ca95373a&"
import script from "./DkIcon.vue?vue&type=script&lang=js&"
export * from "./DkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports